<div :class="content_class">
  <div class="portfolio-chart">
      <div class="superset-embedded-container m-0 p-0 position-relative">

        <!-- Superset Chart -->
        <div :id="chart_id"></div>

        <!-- Loading State -->
        <div v-if="iframe_loading && !iframe_error" class="iframe-loading position-absolute d-flex align-items-center justify-content-center gap-2 fw-bold top-0 bottom-0 start-0 end-0 text-sm text-dark">
          <div class="spinner-border spinner-border-sm me-2" role="status"></div>
          Loading embedded dashboard...
        </div>

        <div v-if="iframe_error" class="iframe-error dashboard-embed-error text-center d-grid m-3 p-3 rounded-3 text-dark bg-white">
          <h5 class="fw-bold mb-2">Dashboard could not be loaded</h5>
          <p class="mb-0">
            The embedded dashboard request failed. Check the Superset dashboard ID, embed permissions, and service worker URL.
          </p>
        </div>

      </div>
    </div>
</div>
